import { MatomoHelper } from "@/helpers";
import { MatomoEventAction, MatomoEventCategory } from "@/types";

type ActionType =
  | MatomoEventAction.ClickFaqItemBusiness
  | MatomoEventAction.ClickFaqItemPrivate
  | MatomoEventAction.ClickFaqItemSchool;

export function useFaqListTracking(type: "company" | "private" | "school") {
  const getAction = (): ActionType => {
    switch (type) {
      case "company":
        return MatomoEventAction.ClickFaqItemBusiness;
      case "private":
        return MatomoEventAction.ClickFaqItemPrivate;
      case "school":
        return MatomoEventAction.ClickFaqItemSchool;
    }
  };

  const trackFaqItemClick = (isOpen: boolean, index: number) => {
    if (!isOpen) {
      return;
    }

    MatomoHelper.sendEvent(MatomoEventCategory.SupportPage, getAction(), `Clicked ${type} FAQ item ${index + 1}`);
  };

  return {
    trackFaqItemClick
  };
}
